import { useNavigate } from "react-router-dom";
import { Grid, InternalStandardProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { messaging } from "JS/Helpers/UserMessaging";
import { Course, DownloadedCourseDetail } from "JS/Models";
import { AppNoDataFound } from "JS/React/Components/AppNoDataFound";
import { useRouting } from "JS/React/Hooks/Routes";
import { useScrollToTop } from "JS/React/Hooks/Media";
import { OfflineListingComponent } from "../../OfflineListingComponent";

const Root = styled("div")(({ theme }) => ({}));

const WrapperLoader = styled(Grid)(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: `calc(100vh - (${theme.footer.height} + ${theme.header.height}))`,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.common.black,
}));

export interface OfflineCourseListProps
    extends InternalStandardProps<
        React.DetailedHTMLProps<
            React.HTMLAttributes<HTMLDivElement>,
            HTMLDivElement
        >
    > {
    downloadedCourses: (Course | DownloadedCourseDetail)[];
}

export const OfflineCourseList = (props: OfflineCourseListProps) => {
    const { className, downloadedCourses: content, ...rest } = props;

    const { linkProvider } = useRouting();
    const navigate = useNavigate();

    useScrollToTop();

    const isDownloadedCourse = (course: Course | DownloadedCourseDetail) =>
        !!(course as DownloadedCourseDetail)?.steps;
    const handleRedirectToDetail = (c: (Course | DownloadedCourseDetail), index: number) => {
        isDownloadedCourse(c) &&
            navigate(
                linkProvider.react
                    .offline()
                    .courses()
                    .detail(c.nid, { scrollTo: index }),
            );
    }
    return (
        <Root className={className} {...rest}>
            {content && content.length > 0 ? (
                <OfflineListingComponent
                    data={content}
                    handleRedirectToCourseDetail={handleRedirectToDetail}
                    controlType="course"
                />
            ) : (
                <WrapperLoader item xs={12} md={12}>
                    <AppNoDataFound
                        notFoundText={messaging?.common?.noDataFound}
                    />
                </WrapperLoader>
            )}
        </Root>
    );
};
